<template>
  <section class="section">
    <div class="container">
      <div class="cr_wrapper">
        <div class="cr_item">
          <div class="cr_item_content">
            <h1>{{ options.headers[value].title }}</h1>
            <h2>{{ options.headers[value].subtitle }}</h2>
            <ul class="cr_steps">
              <li
                :key="item.title"
                v-for="(item, index) in options.headers"
                v-bind:class="{ active: value === index }"
              ></li>
            </ul>
            <div
              :key="item.title"
              v-for="(item, index) in options.headers"
              v-show="value === index"
            >
              <transition name="component-fade" mode="out-in">
                <slot :name="'step-' + index"></slot>
              </transition>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'UStepper',
  props: ['options', 'value'],
  methods: {
    Next() {
      this.value++
    },
  },
  watch: {
    value() {
      this.$emit('input', this.value)
    },
  },
}
</script>
<style scoped>
.cr_wrapper {
  display: grid;
  grid-template-columns: 1fr;
  place-items: center;
  grid-gap: 1em;
  max-width: 800px;
  margin: 0 auto;
}
.cr_wrapper .feature_image {
  padding: 0;
  text-align: left;
}
/* .trainer-signup-background {
  background: transparent url('../../assets/images/trainer-background.svg') 0%
    0% no-repeat padding-box;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 5px;
  align-items: center;
  justify-items: center;
} */
.img-text {
  font-family: 'Open Sans';
  color: whitesmoke;
  font-size: 1.2rem;
  letter-spacing: -1.2px;
}
@media only screen and (max-width: 767px) {
  .cr_wrapper {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 1em;
  }
  .trainer-signup-background {
    grid-template-columns: 1fr;
  }
  .img-text {
    font-size: 14px;
    padding: 1em;
  }
}
</style>
